import * as filterEnum from "enums/filterEnum"
import { ContainmentHoldDTO } from "models/dto/containmentHold"

const dropdown = filterEnum.Dropdown<"containmentInitialHold", ContainmentHoldDTO>

export const Dropdown = () =>
	dropdown({
		field: "containmentInitialHold",
		getter: ({ api }) => api().ContainmentInitialHolds(),
		label: "Containment Hold Options",
	})
